export default {"src":"/_next/static/media/hubspot.97e79ab3.svg","height":26,"width":26,"blurWidth":0,"blurHeight":0};